<script>
  import { infotag } from "@parkingboss/utils";
  import { navigate } from "../navigate";
  import Camera from "./Camera.svelte";
  import Result from "./Result.svelte";

  export let data;
  export let query;
  export let propertyId;

  let loading = false;
  let error = false;

  function loadData(data) {
    
    // initial state is loading with no errors
    loading = true;
    error = false;

    return data.then(d => {
      property = d.property;
      media = d.medias;
      permits = d.permits;
    })
    .catch(err => {
      error = true;
      return Promise.reject(new Error(err));
    })
    .finally(x => {
      loading = false;
    });
  }

  let property = null,
    media = null,
    permits = null;

  $: loadPromise = loadData(data);


  async function checkBarcode(evt) {
    const [photo, value] = await Promise.all([
      evt.detail.photo,
      evt.detail.value
    ]);
    if (value != null) {
      const tagData = infotag.parse(value);
      if (tagData.ref == "media") {
        navigate({ query: { id: tagData.id } });
      }
    }
  }
</script>

<main class:loading class:error>

  {#await loadPromise then ignoreMe}

    <Camera on:barcode={checkBarcode} />
    <Result id={query.id} {media} {permits} {propertyId} />

  {:catch err}
    <h1>Whoops!</h1>
    <p>We had trouble loading data, please check your connection and try again.</p>
  {/await}
</main>
